import nextApi from "./next-api";

const getSuccess360 = (
  page = 1,
  limit = 12,
  query = "",
  examType = "",
  status = ""
) => {
  let url = `cms/success360?page=${page}&limit=${limit}`;

  if (query) {
    url += `&query=${encodeURIComponent(query)}`;
  }

  if (examType && examType !== "All") {
    url += `&examType=${encodeURIComponent(examType)}`;
  }

  if (status && status !== "All") {
    const statusValue = status === "Active" ? "1" : "0";
    url += `&status=${statusValue}`;
  }

  return nextApi.get(url);
};

const createSuccess360 = (data) => {
  return nextApi.post("cms/success360", data);
};

const updateSuccess360 = (id, data) => {
  return nextApi.put(`cms/success360?id=${id}`, data);
};

const deleteSuccess360 = (id) => {
  return nextApi.delete(`cms/success360?id=${id}`);
};

const getSuccess360Banner = () => {
  return nextApi.get("cms/uploadImage?type=success360");
};
const createSuccess360Banner = (data) => {
  return nextApi.post("cms/uploadImage?type=success360", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
const updateSuccess360Banner = (id, data) => {
  return nextApi.put(`cms/uploadImage?type=success360&id=${id}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
const deleteSuccess360Banner = (id) => {
  return nextApi.delete(`cms/uploadImage?type=success360&id=${id}`);
};
const Success360Service = {
  getSuccess360,
  createSuccess360,
  updateSuccess360,
  deleteSuccess360,
  getSuccess360Banner,
  createSuccess360Banner,
  updateSuccess360Banner,
  deleteSuccess360Banner,
};
export default Success360Service;
